import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TCurrencyApi } from './types';

export const currency: TCurrencyApi = {
	getCurrencyList: (payload) =>
		http.post(endpoint.currency.CURRENCY_LIST, payload).then((response) => response.data),
	getCurrencyDetails: (payload) =>
		http.get(endpoint.currency.CURRENCY_DETAILS(payload.id)).then((response) => response.data),
	updateCurrency: (payload) =>
		http
			.put(endpoint.currency.CURRENCY_UPDATE(payload.id), payload.body)
			.then((response) => response.data),
};
